export default __webpack_public_path__ + "static/media/Beast Hunter's Barbs.c98db7bc.jpg";